/* eslint-disable import/no-unused-modules */
/* eslint-disable @typescript-eslint/no-unused-vars */
// import { TrackJS } from 'trackjs';
import Route from 'route-parser';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useNuxtApp } from '#app';
import { stripTrailingSlash } from '~/helpers/string.helper';
import type { Argument } from '~/stores/filter';
import { useFilterStore } from '~/stores/filter';
import { usePageContentStore } from '~/stores/pageContent';
import { useSiteContentStore } from '~/stores/siteContent';
// import SiteContentModule from '~/store/siteContent';

export function useFilter() {
  const { $store } = useNuxtApp();
  const route = useRoute();
  const filterStore = useFilterStore();
  const pageContentStore = usePageContentStore();

  const filterArguments = computed<Argument[]>(() => {
    return filterStore.arguments;
  });

  const createQueryParams = (filters: Argument[]): Record<string, string> => {
    const queryParams: Record<string, string> = filters.reduce(
      (total, filter) => ({
        ...total,
        [filter.key]: filter.value,
      }),
      {}
    );

    if (queryParams.page && Number(queryParams.page) <= 1) {
      delete queryParams.page;
    }

    return queryParams;
  };

  const urlWithFilters = computed<string>(() => {
    let url = stripTrailingSlash(pageContentStore.route);
    const filters = [...filterArguments.value];

    url = `${url}/${serializeQuery(createQueryParams(filters))}`;

    return url;
  });

  const urlWithFiltersAndSort = computed<string>(() => {
    let url = stripTrailingSlash(pageContentStore.route);
    const filters = [...filterArguments.value, { key: 'sort', value: filterStore.selectedSort }];

    url = `${url}/${serializeQuery(createQueryParams(filters))}`;

    return url;
  });

  const getArgumentsFromUrl = (): Argument[] => {
    // Get query params from url
    const queries: Argument[] = Object.entries(route.query).map(([key, value]) => {
      return {
        key,
        value: String(value), //
      };
    });

    // Get params from url
    const path = stripTrailingSlash(pageContentStore.route);
    const paramsInUrl = new Route(`${path}/:brand(/:model)(/)`).match(route.fullPath);

    const params: Argument[] = Object.entries(paramsInUrl)
      .filter(([_, value]) => !!value)
      .map(([key, value]) => {
        return {
          key,
          value: String(value),
        };
      });

    return [...queries, ...params];
  };

  const serializeQuery = (query: { [key: string]: string | (string | null)[] }): string => {
    const str = [];
    for (const k in query) {
      if (query.hasOwnProperty(k)) {
        str.push(`${encodeURIComponent(k)}=${encodeURIComponent(query[k] as string).replaceAll('%2C', ',')}`);
      }
    }

    return str.length > 0 ? `?${str.join('&')}` : '';
  };

  const createUrl = (baseUrl: string, filterArguments: Argument[]): string => {
    let url = baseUrl;
    const query: Record<string, string> = {};
    const filters = JSON.parse(JSON.stringify(filterArguments)) as Argument[];

    const brand = filters?.find((f) => f.key === 'brand');
    if (brand !== undefined && !brand.value.includes(',')) {
      url = `${url}/${brand?.value}`;

      const index = filters.indexOf(brand);
      if (index > -1) {
        filters.splice(index, 1);
      }

      const model = filters?.find((f) => f.key === 'model');
      if (model !== undefined && !model.value.includes(',')) {
        url = `${url}/${model?.value}`;

        const index = filters.indexOf(model);
        if (index > -1) {
          filters.splice(index, 1);
        }
      }
    }

    filters.forEach((filter) => {
      query[`${filter.key}`] = filter.value;
    });
    return `${url}${serializeQuery(query)}`;
  };

  return { filterArguments, urlWithFilters, urlWithFiltersAndSort, getArgumentsFromUrl, serializeQuery, createUrl, createQueryParams };
}
